import { useState } from 'react';
import { SidebarSimple } from '../../design-system/icons';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTitle } from '../ui/sheet';
import { CampaignNavSidebar, type CampaignNavSidebarProps } from './CampaignNavSidebar';
import { useMediaQuery } from './useMediaQuery';

// Below Tailwind's md breakpoint the 224 px column leaves no room for the
// page (E2E O6 at 375 px), so it moves into a sheet.
const NARROW = '(max-width: 767px)';

export function ResponsiveCampaignNav(props: CampaignNavSidebarProps) {
  const narrow = useMediaQuery(NARROW);
  const [open, setOpen] = useState(false);
  if (!narrow) return <CampaignNavSidebar {...props} />;

  return (
    <div className="flex items-center gap-2 border-b border-border bg-stone-50 px-4 py-2">
      <Button type="button" variant="outline" size="sm" aria-label="Campaign menu" onClick={() => setOpen(true)}>
        <SidebarSimple size={16} />
        Menu
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[264px] max-w-[85vw] p-0">
          <SheetTitle className="sr-only">Campaign menu</SheetTitle>
          <CampaignNavSidebar
            {...props}
            collapsed={false}
            onToggleCollapse={undefined}
            onTabChange={(id, sub) => {
              setOpen(false);
              props.onTabChange?.(id, sub);
            }}
            onBack={() => {
              setOpen(false);
              props.onBack();
            }}
          />
        </SheetContent>
      </Sheet>
    </div>
  );
}
